import React from 'react'
import { View } from 'react-native'
import { useNavigation } from '@react-navigation/native'
import { StackNavigationProp } from '@react-navigation/stack'
import { StyleService, useStyleSheet } from '@src/style/service'
import { NavigationCard } from '@src/navigation/components/NavigationCard'
import { User } from '@src/utils'
import { MobileAppFeature } from '@src/types'
import { useLazyScreenPreload } from '@src/navigation/utils'
import { CommonAuthorizedStackParamList } from '@src/navigation/types'

export const ListHeader = () => {
  const styles = useStyleSheet(themedStyles)
  const navigation = useNavigation<StackNavigationProp<CommonAuthorizedStackParamList>>()

  const isActivateOwnSensorEnabled = User.hasFeature(MobileAppFeature.ActivateOwnSensor)

  useLazyScreenPreload('SupportHub')

  const handleFAQsPress = () => {
    navigation.navigate('SupportHub')
  }

  const handleSensorGuidesPress = () => {
    navigation.navigate('OwnSensorSelection', { nextScreen: 'ConfirmSensorSelection' })
  }

  return (
    <View style={styles.container}>
      <NavigationCard iconName="question" title="FAQs" onPress={handleFAQsPress} />
      {isActivateOwnSensorEnabled && (
        <NavigationCard
          iconName="radio-button"
          title="Sensor Guides"
          onPress={handleSensorGuidesPress}
        />
      )}
    </View>
  )
}

const themedStyles = StyleService.create({
  container: {
    flex: 1,
    flexDirection: 'row',
    gap: 8,
  },
})
